import { Link } from 'react-router-dom';
import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';

import { UitkCard, UitkCardTextSegment } from 'uitk-react-cards';

const LinkTracked = ClickTracker(Link);

export interface SavingsOptionProps {
  dateOption: any;
  attachedCard?: boolean;
}

export class SavingsOption extends React.Component<SavingsOptionProps> {
  public static defaultProps = {
    attachedCard: false,
  };

  public render() {
    const { dateOption, attachedCard } = this.props;
    const { alternateDateMessage, url } = dateOption;

    return (
      <LinkTracked to={url} replace={true} linkName="Meta Default Savings Option" rfrr={'RoomsAndRates.SaveMoneyAltDates'}>
        <UitkCard className="uitk-type-center">
          <UitkCardTextSegment className={attachedCard ? 'uitk-card-separator-top' : ''}>{alternateDateMessage}</UitkCardTextSegment>
        </UitkCard>
      </LinkTracked>
    );
  }
}
